import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { arrayOf, shape, any, string, func } from "prop-types";
import type { Dispatch, SetStateAction } from "react";

type CrumbValue = string | number;

interface PageIndicatorCrumb {
  value: CrumbValue;
  label: string;
}

interface PageIndicatorProps {
  view?: string;
  setView?: Dispatch<SetStateAction<string>> | ((value: CrumbValue) => void);
  gettext?: (key: string) => string;
  crumbs: PageIndicatorCrumb[];
}

/**
 *
 * @param props
 */
export default function PageIndicator(props: PageIndicatorProps) {
  const {
    view,
    setView,
    // gettext,
    crumbs,
  } = props;

  /**
   *
   * @param value
   */
  function handleClick(value: CrumbValue) {
    if (typeof value === "string" && setView) {
      setView(value);
    }
  }

  const getCrumbs = () => {
    const index = crumbs.findIndex(
      (crumb: PageIndicatorCrumb) => crumb.value === view,
    );
    const filteredCrumbs = index >= 0 ? crumbs.slice(0, index + 1) : crumbs;
    return filteredCrumbs.map((crumb: PageIndicatorCrumb) => (
      // <React.Fragment key={crumb.label}>
      <Link
        key={crumb.label}
        underline="none"
        color={view === crumb.value ? "#27272A" : "inherit"}
        onClick={() => handleClick(crumb.value)}
      >
        {crumb.label}
      </Link>
      // </React.Fragment>
    ));
  };

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ fontSize: "14px", pb: 1 }}
    >
      {getCrumbs()}
    </Breadcrumbs>
  );
}

PageIndicator.propTypes = {
  crumbs: arrayOf(
    shape({
      value: any,
      label: string,
    }),
  ).isRequired,
  setView: func,
  view: string,
};
